import { render } from "./RequestBoard.vue?vue&type=template&id=2683507e&scoped=true"
import script from "./RequestBoard.vue?vue&type=script&lang=js"
export * from "./RequestBoard.vue?vue&type=script&lang=js"

import "./RequestBoard.vue?vue&type=style&index=0&id=2683507e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2683507e"]])

export default __exports__